import React, { useState } from 'react';
import StatisticBoxes from '../components/sevice3bars';

interface IconProps {
  className?: string;
}

interface ServiceCardProps {
  icon: React.FC<IconProps>;
  title: string;
  description: string;
  isHovered: boolean;
  onHover: (isHovered: boolean) => void;
}

const BriefcaseIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M20 7H4C2.89543 7 2 7.89543 2 9V19C2 20.1046 2.89543 21 4 21H20C21.1046 21 22 20.1046 22 19V9C22 7.89543 21.1046 7 20 7Z M16 7V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V7" strokeWidth="2" fill="none" stroke="currentColor"/>
  </svg>
);

const ClockIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <circle cx="12" cy="12" r="10" strokeWidth="2" fill="none" stroke="currentColor"/>
    <path d="M12 6V12L16 14" strokeWidth="2" stroke="currentColor" fill="none"/>
  </svg>
);

const SupportIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M3 18V12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12V18" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M21 19C21 20.1046 20.1046 21 19 21H18C16.8954 21 16 20.1046 16 19V15C16 13.8954 16.8954 13 18 13H21V19ZM3 19C3 20.1046 3.89543 21 5 21H6C7.10457 21 8 20.1046 8 19V15C8 13.8954 7.10457 13 6 13H3V19Z" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

const GraduationCapIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M2 7V14" stroke="currentColor" strokeWidth="2"/>
    <path d="M7 9.5V16C7 16 9.5 18 12 18C14.5 18 17 16 17 16V9.5" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

const WalletIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M20 6H4C2.89543 6 2 6.89543 2 8V16C2 17.1046 2.89543 18 4 18H20C21.1046 18 22 17.1046 22 16V8C22 6.89543 21.1046 6 20 6Z" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M16 12C16 13.1046 16.8954 14 18 14C19.1046 14 20 13.1046 20 12C20 10.8954 19.1046 10 18 10C16.8954 10 16 10.8954 16 12Z" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

const CustomizeIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M12 6V4M12 6C10.8954 6 10 6.89543 10 8C10 9.10457 10.8954 10 12 10M12 6C13.1046 6 14 6.89543 14 8C14 9.10457 13.1046 10 12 10M12 10V20M6 18V16M6 16C4.89543 16 4 15.1046 4 14C4 12.8954 4.89543 12 6 12C7.10457 12 8 12.8954 8 14C8 15.1046 7.10457 16 6 16M6 16V4M18 18V16M18 16C16.8954 16 16 15.1046 16 14C16 12.8954 16.8954 12 18 12C19.1046 12 20 12.8954 20 14C20 15.1046 19.1046 16 18 16M18 16V4" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

const BuildingIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M19 21V5C19 3.89543 18.1046 3 17 3H7C5.89543 3 5 3.89543 5 5V21" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M3 21H21" stroke="currentColor" strokeWidth="2"/>
    <path d="M9 7H15M9 11H15M9 15H15" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const GearIcon: React.FC<IconProps> = ({ className }) => (
  <svg viewBox="0 0 24 24" className={className}>
    <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M19.4 15C19.1277 15.6171 19.2583 16.3378 19.73 16.83L19.79 16.89C20.1827 17.2825 20.4011 17.8026 20.4011 18.345C20.4011 18.8874 20.1827 19.4075 19.79 19.8L19.78 19.81C19.3875 20.2027 18.8674 20.4211 18.325 20.4211C17.7826 20.4211 17.2625 20.2027 16.87 19.81L16.81 19.75C16.3178 19.2783 15.5971 19.1477 14.98 19.42C14.3755 19.6801 13.9796 20.2502 13.98 20.89V21C13.98 22.1046 13.0846 23 11.98 23H11.93C10.8254 23 9.93 22.1046 9.93 21V20.89C9.92728 20.2409 9.51545 19.6651 8.9 19.41C8.28292 19.1377 7.56217 19.2683 7.07 19.74L7.01 19.8C6.61751 20.1927 6.09738 20.4111 5.555 20.4111C5.01262 20.4111 4.49249 20.1927 4.1 19.8L4.09 19.79C3.69733 19.3975 3.47894 18.8774 3.47894 18.335C3.47894 17.7926 3.69733 17.2725 4.09 16.88L4.15 16.82C4.62167 16.3278 4.75235 15.6071 4.48 14.99C4.21995 14.3855 3.64987 13.9896 3.01 13.99H2.9C1.79543 13.99 0.9 13.0946 0.9 11.99V11.94C0.9 10.8354 1.79543 9.94 2.9 9.94H3.01C3.65909 9.93728 4.23487 9.52545 4.49 8.91C4.76235 8.29292 4.63167 7.57217 4.16 7.08L4.1 7.02C3.70733 6.62751 3.48894 6.10738 3.48894 5.565C3.48894 5.02262 3.70733 4.50249 4.1 4.11L4.11 4.1C4.50249 3.70733 5.02262 3.48894 5.565 3.48894C6.10738 3.48894 6.62751 3.70733 7.02 4.1L7.08 4.16C7.57217 4.63167 8.29292 4.76235 8.91 4.49H9C9.60447 4.22995 10.0004 3.65987 10 3.02V2.91C10 1.80543 10.8954 0.91 12 0.91H12.05C13.1546 0.91 14.05 1.80543 14.05 2.91V3.02C14.0496 3.65987 14.4455 4.22995 15.05 4.49C15.6671 4.76235 16.3878 4.63167 16.88 4.16L16.94 4.1C17.3325 3.70733 17.8526 3.48894 18.395 3.48894C18.9374 3.48894 19.4575 3.70733 19.85 4.1L19.86 4.11C20.2527 4.50249 20.4711 5.02262 20.4711 5.565C20.4711 6.10738 20.2527 6.62751 19.86 7.02L19.8 7.08C19.3283 7.57217 19.1977 8.29292 19.47 8.91V9C19.7301 9.60447 20.3002 10.0004 20.94 10H21.05C22.1546 10 23.05 10.8954 23.05 12V12.05C23.05 13.1546 22.1546 14.05 21.05 14.05H20.94C20.3002 14.0496 19.7301 14.4455 19.47 15.05V15" stroke="currentColor" strokeWidth="2" fill="none"/>
  </svg>
);

const ServiceCard: React.FC<ServiceCardProps> = ({ icon: Icon, title, description, isHovered, onHover }) => {
  const baseClasses = "relative h-full transition-all duration-300";
  const hoverClasses = isHovered 
    ? "bg-[#F7A928] text-white" 
    : "bg-white hover:bg-[#F7A928] hover:text-white";

  return (
    <div className="relative pt-8">
      <div 
        className={`${baseClasses} ${hoverClasses}`}
        onMouseEnter={() => onHover(true)}
        onMouseLeave={() => onHover(false)}
      >
        {/* Centered icon container */}
        <div className="absolute -top-8 left-0 w-full flex justify-center">
          <div className={`w-16 h-16 relative flex items-center justify-center transition-all duration-300
            ${isHovered 
              ? 'bg-[#234152] rounded-full' 
              : 'border-2 border-[#003087] border-dashed rounded-full bg-white'
            }`}
          >
            <div className="w-8 h-8">
              <Icon className={`w-full h-full ${isHovered ? 'text-white' : 'text-[#003087]'}`} />
            </div>
          </div>
        </div>

        {/* Card content */}
        <div className="p-8 pt-12">
          <h3 className="text-xl font-bold mb-4 text-center text-blue-950">{title}</h3>
          <p className="text-sm leading-relaxed opacity-90 text-center text-blue-950">{description}</p>
        </div>
      </div>
    </div>
  );
};

interface ServiceData {
  icon: React.FC<IconProps>;
  title: string;
  description: string;
}

const WhyChooseUs = () => {
  const [hoveredIndex, setHoveredIndex] = useState<number>(0);

  const services: ServiceData[] = [
    {
      icon: BriefcaseIcon,
      title: "Top-Notch Papers",
      description: "Our professional writers deliver 100% plagiarism-free essays tailored to your instructions. We ensure compliance with academic standards and provide quality assurance for originality.",
    },
    {
      icon: ClockIcon,
      title: "Timely Delivery",
      description: "Get your assignments on time, with turnarounds starting from just one hour for short projects. Larger projects are handled with precision and efficient communication.",
    },
    {
      icon: SupportIcon,
      title: "24/7/365 Support",
      description: "We provide round-the-clock assistance to address your questions or concerns. Our dedicated support team ensures seamless communication and service delivery.",
    },
    {
      icon: GraduationCapIcon,
      title: "Subject Expertise",
      description: "Our team includes experts across various academic fields, ensuring your assignments meet the highest standards of subject accuracy and depth.",
    },
    {
      icon: BuildingIcon,
      title: "Affordable Pricing",
      description: "We offer competitive rates for assignment writing without compromising on quality, making professional help accessible to all students.",
    },
    {
      icon: WalletIcon,
      title: "Customized Solutions",
      description: "Every assignment is tailored to your unique requirements, delivering personalized content that aligns with your academic goals and guidelines.",
    },
    {
      icon: CustomizeIcon,
      title: "Full Satisfaction",
      description: "A business has higher possibilities of accomplishment if your market is growing.",
    },
    {
      icon: GearIcon,
      title: "Prompt Delivery",
      description: "A business has higher possibilities of accomplishment if your market is growing.",
    }
  ];

  return (
    <div className="w-full bg-gray-100 p-8" id="services">
      <div className="text-center mb-12">
        <h1 className="text-xl sm:text-2xl font-bold text-blue-950">
        Why Choose Us for Your{" "}
          <span
            style={{
              background: "linear-gradient(-96deg, rgb(255 255 255 / 0%) 0%, rgb(255 249 220 / 0%) 28%, rgb(253, 103, 16) 100%, rgb(255 255 255 / 0%) 100%)",
              padding: "0px 5px",
            }}
          >
             Assignment Writing
          </span>
           Needs?
        </h1>
        <p className="text-sm text-gray-600">Work with the best subject-matter experts anytime you need them.</p>
      </div>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <ServiceCard
              key={index}
              icon={service.icon}
              title={service.title}
              description={service.description}
              isHovered={index === hoveredIndex}
              onHover={(isHovered: boolean) => isHovered ? setHoveredIndex(index) : setHoveredIndex(-1)}
            />
          ))}
        </div>
      </div>
      <StatisticBoxes />
    </div>
  );
};

export default WhyChooseUs;